export default "__VITE_ASSET__DnOOqfY4__"